import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import SafeComponent from '../../shared/SafeComponent';
import TrustedByItem from '../TrustedByItem';
import { COMPANIES_WHO_TRUST, SANDBOX_COMPANIES_WHO_TRUST } from './constants';

interface Props {
    compact?: boolean;
    sandbox?: boolean;
}

const getLogosGap = ({ compact, sandbox }: Required<Props>) => {
    if (sandbox) {
        return '10';
    }

    return compact ? '8' : '12';
};

const TrustedBySection = ({ compact = false, sandbox = false }: Props) => (
    <Stack
        gap={compact ? '6' : { default: '3', md: '14' }}
        direction={{ default: 'column', md: 'row' }}
        justifyContent={compact ? 'center' : 'spaceBetween'}
        alignItems={compact ? 'center' : 'flexStart'}
        width="100%"
    >
        <Typography color="white" fontWeight="normal" whiteSpace="nowrap" size={sandbox ? 'b_sm' : undefined}>
            <I18n k="logged_out_homepage.trusted_by.title" />:
        </Typography>
        <Stack
            direction="row"
            gap={getLogosGap({ compact, sandbox })}
            wrap="wrap"
            width={compact ? 'auto' : '100%'}
            justifyContent={compact ? 'center' : 'flexStart'}
            alignItems="center"
        >
            {(sandbox ? SANDBOX_COMPANIES_WHO_TRUST : COMPANIES_WHO_TRUST).map(({ src, alt }) => (
                <TrustedByItem src={src} alt={alt} key={alt} />
            ))}
        </Stack>
    </Stack>
);

export default SafeComponent(TrustedBySection);
